import { useContext } from "react";
import { Link } from "react-router-dom";

import FormProvider from "../../../context/FormContext";

import "./Sidebar.css";
import home from "../../../assets/home.svg";
import stock_reports from "../../../assets/stock_reports.svg";
import master_data from "../../../assets/master_data.svg";

const Sidebar = () => {
  const { setIsFormOpen } = useContext(FormProvider);

  // const registerUserHandler = (e) => {
  //   e.preventDefault();
  //   setIsFormOpen(!isFormOpen);
  // };

  const closeRegisterFormHandler = (e) => {
    e.preventDefault();
    setIsFormOpen(false);
  };

  return (
    <aside>
      <nav className="nav-container">
        <ul className="nav-list">
          <li onClick={closeRegisterFormHandler} className="list-item ">
            <Link to="/supervisor" className=" link ">
              <img src={home} className="img img-home" alt="" />
              <p className="desc ">Home</p>
            </Link>
          </li>

          <li onClick={closeRegisterFormHandler} className="list-item">
            <Link to="/stockist-report" className=" link link-reports">
              <img src={stock_reports} className="img img-reports" alt="" />
              <p className="desc desc-reports">
                Stockist
                <br /> Report
              </p>
            </Link>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
